import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { AssetState, FlowState, ProductState } from '@platform-frontend/checkout';
import { TravelTicketRoute } from '@platform-frontend/marketplace';
import { Observable, switchMap } from 'rxjs';

@Component({
  selector: 'yat-commercial-header-travel-ticket-description',
  templateUrl: './commercial-header-travel-ticket-description.component.html',
  styleUrls: ['./commercial-header-travel-ticket-description.component.scss']
})
export class CommercialHeaderTravelTicketDescriptionComponent implements OnInit {
  constructor(private readonly store: Store) {}

  route$: Observable<TravelTicketRoute | null>;

  ngOnInit(): void {
    this.route$ = this.store
      .select(FlowState.isOrderToBeManaged)
      .pipe(switchMap(isOrderToBeManaged => this.store.select(isOrderToBeManaged ? AssetState.travelTicketRoute : ProductState.travelTicketRoute)));
  }
}
